import { Loading } from './Loading'

export function SuspenseFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loading size="lg" text="로딩 중..." fullScreen />
    </div>
  )
}

